/**
 * Application-wide constants
 * Centralized configuration for magic strings, API endpoints, and application settings
 */

// Account Types
export const ACCOUNT_TYPES = {
  STUDENT: 'student',
  EMPLOYER: 'werkgever',
  ADMIN: 'admin',
};

// Validation Rules
export const VALIDATION_RULES = {
  PASSWORD: {
    MIN_LENGTH: 8,
    MAX_LENGTH: 128,
  },
  EMAIL: {
    REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  },
};

// Token Expiry
export const TOKEN_EXPIRY = {
  CONFIRMATION: '24 uur',
  PASSWORD_RESET: '15 minuten',
};

// UI Messages
export const MESSAGES = {
  SUCCESS: {
    REGISTRATION: 'Registratie succesvol! Controleer je email om je account te bevestigen.',
    ACCOUNT_CONFIRMED: 'Je account is succesvol bevestigd!',
    PASSWORD_RESET_SENT: 'Reset link succesvol verzonden! Controleer je inbox voor verdere instructies.',
    PASSWORD_CHANGED: 'Je wachtwoord is succesvol gewijzigd. Je wordt doorgestuurd naar de inlogpagina.',
  },
  ERROR: {
    GENERIC: 'Er ging iets mis. Probeer het opnieuw.',
    NETWORK: 'Er ging iets mis bij het verbinden met de server. Controleer je internetverbinding en probeer het opnieuw.',
    INVALID_CREDENTIALS: 'Ongeldige gegevens. Controleer je invoer.',
    EMAIL_EXISTS: 'Dit e-mailadres is al geregistreerd.',
    SERVER_ERROR: 'Serverfout. Probeer het later opnieuw.',
    ACCOUNT_NOT_VERIFIED: 'Bevestig eerst je e-mailadres via de link in de e-mail.',
    INVALID_TOKEN: 'Ongeldig bevestigingstoken. Vraag een nieuwe bevestigingslink aan.',
    TOKEN_EXPIRED: 'De reset link is ongeldig, verlopen of al gebruikt.',
  },
};

// Sector Options (for employers)
export const SECTOR_OPTIONS = [
  { value: '', label: 'Selecteer sector' },
  { value: 'IT', label: 'IT & Software' },
  { value: 'Finance', label: 'Financiën & Banking' },
  { value: 'Healthcare', label: 'Zorgverlening' },
  { value: 'Education', label: 'Onderwijs' },
  { value: 'Retail', label: 'Retail & E-commerce' },
  { value: 'Manufacturing', label: 'Productie & Manufacturing' },
  { value: 'Construction', label: 'Bouw & Constructie' },
  { value: 'Marketing', label: 'Marketing & Communicatie' },
  { value: 'Logistics', label: 'Logistiek & Transport' },
  { value: 'Other', label: 'Overig' },
];

// Study Levels (for enhanced registration)
export const STUDY_LEVELS = ['', 'MBO', 'HBO', 'WO'];

// Study Years
export const STUDY_YEARS = ['', '1', '2', '3', '4', '5+'];

// Work Types
export const WORK_TYPES = ['', 'Parttime', 'Fulltime', 'Bijbaan', 'Stage', 'Flex'];

// Availability Options
export const AVAILABILITY_OPTIONS = ['', '8-16 uur', '16-24 uur', '24-32 uur', '32+ uur'];

// Routes
export const ROUTES = {
  HOME: '/',
  LOGIN: '/inloggen',
  REGISTER: '/registreren',
  CONFIRM_ACCOUNT: '/account-bevestigen',
  FORGOT_PASSWORD: '/wachtwoord-vergeten',
  RESET_PASSWORD: '/wachtwoord-reset',
  DASHBOARD: '/dashboard',
  DASHBOARD_WERKGEVER: '/werkgever/dashboard',
  DASHBOARD_STUDENT: '/student/dashboard',
  CHAT: '/chat',
  CONVERSATION: (id) => `/chat/${id}`,
  ADMIN_DASHBOARD: '/admin',
};

// Animation Delays (for UI)
export const ANIMATION_DELAYS = {
  SHORT: 100,
  MEDIUM: 500,
  LONG: 1000,
  REDIRECT: 4000,
};

// HTTP Status Codes
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
};
